import { callToGetRequestDetailsWatcher, callToGetRequests, callToGetRequestsPaginated, callToLoadUserOnboardingFormInitialData, callToSubmitPodOnboarding, callToSubmitUserOnboardForm } from 'pages/onboarding/ducks/saga';
import { callToloadInstanceTypesWatcher } from 'pages/mlops/ducks/saga';
import { callToFetchCloudServicesWatcher } from 'pages/cloud-service-provisioning/ducks/saga';
import { callToFetchTeamDirectoryWatcher } from 'pages/team-directory/ducks/saga';
import { fork, all } from 'redux-saga/effects'
import { callToGetUserRoles } from '../pages/onboarding/ducks/saga';

function* rootSaga() {
     yield all(
        [
        fork(callToSubmitUserOnboardForm),
        fork(callToLoadUserOnboardingFormInitialData),
        fork(callToGetRequests),
        fork(callToGetRequestsPaginated),
        fork(callToloadInstanceTypesWatcher),
        fork(callToGetUserRoles),
        fork(callToGetRequestDetailsWatcher),
        fork(callToSubmitPodOnboarding),
        fork(callToFetchCloudServicesWatcher), 
        fork(callToFetchTeamDirectoryWatcher),
     ]
    );
}

export default rootSaga
